import React from 'react';
import { useNavPillsIndicator } from 'hooks/useNavPillsIndicator';
import { TaskHistoryCardProps } from '../types';
import HistoryListView from './HistoryListView';
import DailyRouteView from './DailyRouteView';
import ProjectFilterDropdown from 'component/ProjectFilterDropdown';

const TaskHistoryCard: React.FC<TaskHistoryCardProps> = ({
  history,
  historyByDate,
  loading,
  historyByDateLoading,
  historyViewType,
  contentHeight,
  search,
  currentPage,
  pageSize,
  totalRecords,
  historyByDateTotalRecords,
  totalPages,
  selectedDate,
  userId,
  projectList = [],
  selectedProjectId = null,
  onProjectChange,
  onSearchChange,
  onSearchSubmit,
  onHistoryViewTypeChange,
  onPageChange,
  onPageSizeChange,
  onDateChange
}) => {
  const hasHistory = history && history.length > 0;
  const hasHistoryByDate = historyByDate && historyByDate.length > 0;
  const { navRef: historyViewNavRef, indicatorStyle: historyViewIndicatorStyle } = useNavPillsIndicator(historyViewType);

  return (
    <div className="card h-100 border" style={{ minHeight: '500px' }}>
      <div className="card-header bg-light border-bottom">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0 fw-bold">Task History</h6>
          <div className="d-flex align-items-center">
            {(hasHistory || hasHistoryByDate) && !loading && !historyByDateLoading && (
              <span className="badge bg-secondary me-2">
                {historyViewType === 'all' ? totalRecords : historyByDateTotalRecords}
              </span>
            )}

            <div ref={historyViewNavRef} className="nav-pills-animated h-100">
              <div
                className="nav-pill-indicator"
                style={historyViewIndicatorStyle}
              />
              <button
                type="button"
                className={`nav-link btn ${historyViewType === "all" ? "active" : ""}`}
                onClick={() => onHistoryViewTypeChange('all')}
              >
                <i className="fa-solid fa-list-check me-1"></i> ALL
              </button>
              <button
                type="button"
                className={`nav-link btn ${historyViewType === "daily-route" ? "active" : ""}`}
                onClick={() => onHistoryViewTypeChange('daily-route')}
              >
                <i className="fa-solid fa-route me-1"></i> Daily Route
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body p-0 d-flex flex-column" style={{
        flex: 1,
        height: `calc(${contentHeight} + ${(hasHistory && historyViewType === 'all') || (hasHistoryByDate && historyViewType === 'daily-route') ? '70px' : '0px'})`
      }}>
        {historyViewType === 'all' && (
          <div className="p-3 border-bottom">
            <form className="d-flex gap-2" onSubmit={onSearchSubmit}>
              <ProjectFilterDropdown
                projects={Array.isArray(projectList) ? projectList : []}
                defaultSelectedId={selectedProjectId}
                allowAllProject={true}
                onChange={(p) => onProjectChange && onProjectChange(p ? p.id : null)}
              />
              <input
                type="text"
                className="form-control form-control-compact"
                placeholder="Search history..."
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                disabled={!userId}
              />
              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={!userId}
              >
                <i className="fa-solid fa-search"></i>
              </button>
            </form>
          </div>
        )}

        <div className="flex-grow-1 position-relative" style={{ overflow: 'hidden' }}>
          <div
            style={{
              display: historyViewType === 'all' ? 'block' : 'none',
              height: '100%',
              overflowY: 'auto',
              position: 'relative',
            }}
          >
            <HistoryListView
              history={history}
              loading={loading}
              contentHeight={contentHeight}
              currentPage={currentPage}
              pageSize={pageSize}
              totalRecords={totalRecords}
              totalPages={totalPages}
              onPageChange={onPageChange}
              onPageSizeChange={onPageSizeChange}
            />
          </div>

          <div
            style={{
              display: historyViewType === 'daily-route' ? 'block' : 'none',
              position: 'absolute',
              inset: 0,
            }}
          >
            <DailyRouteView
              key={`daily-route-${selectedDate}`}
              historyByDate={historyByDate}
              loading={historyByDateLoading}
              contentHeight={contentHeight}
              selectedDate={selectedDate}
              onDateChange={onDateChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskHistoryCard;
